import React from 'react'

const MARGIN = 15

function isUrl(s) {
  if (typeof(s)==='string'&&s.length>0) {
    return s.startsWith('http')&&s.indexOf('://')>0
  }
  return false
}

const ObjectRenderer=props=>{
  const {t,languageKey,value,margin,className} = props
  if (typeof(value)==='string'&&value.length>0) {
    if (isUrl(value)) {
      return (
        <div className="ant-list-item-meta-description">
          <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>
        </div>
      )
    }
    return <div className="ant-list-item-meta-description">{value}</div>
  }
  if (Array.isArray(value)&&value.length>0) {
    const m = (()=>{
      if (typeof(margin)==='number') {
        return margin+MARGIN
      }
      return MARGIN
    })()
    const style = {
      marginLeft: margin||0,
    }
    return (
      <div className={`ant-list ${className||''}`} style={style}>
        {
          value.map((e,i)=>(
            <ObjectRenderer key={i} t={t} languageKey={languageKey} value={e} margin={m} />
          ))
        }
      </div>
    )
  }
  if (typeof(value)==='object'&&value!==null) {
    const keys = Object.keys(value)
    const m = margin||0
    const style = {
      marginLeft: m,
    }
    if (Array.isArray(keys)&&keys.length>0) {
      return (
        <div className={`ant-list ${className}`} style={style}>
          {
            keys.map((e,i)=>(
              <div key={i} className="ant-list-item">
                <div className="ant-list-item-meta">
                  <div className="ant-list-item-meta-content">
                    <h4 className="ant-list-item-meta-title">{t(`${languageKey}:${e}`)}</h4>
                    <ObjectRenderer t={t} languageKey={languageKey} value={value[e]} className="ml-3" />
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      )
    }
  }
  return (
    <div><pre><code>{JSON.stringify(value,null,2)}</code></pre></div>
  )
}

export default ObjectRenderer
